import { Box } from '@mui/material';

interface PageContainerProps {
  children: any;
  sx?: any;
  dataTestId?: string;
}

function PageContainer(props: PageContainerProps) {
  const { children, sx, dataTestId = '' } = props;

  return (
    <Box
      data-testid={dataTestId}
      sx={{
        flexGrow: 1,
        pb: 3,
        px: {
          xs: 2,
          sm: 3,
          md: 4,
          lg: 6,
          xl: 8,
        },
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        height: '100%',
        boxSizing: 'border-box',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
export default PageContainer;
